/* One quiet legal line, with the Roblox disclaimer beneath it. */
export function SiteFooter({ className = '' }: { className?: string }) {
  return (
    <footer className={`legal-footer ${className}`}>
      © {new Date().getFullYear()} rrroblox.com · <a href="/terms">Terms of Service</a>
      <small className="legal-footer-note">
        rrroblox.com is not affiliated with Roblox Corporation.
      </small>
    </footer>
  );
}
